<template>
	<div class="container-fluid">
		<div class="" v-show="errors !== null">
			<save-error
				@close="errors = null"
				:errors="errors"
			/>			
		</div>

    	<div class="row d-flex justify-content-center align-items-center text-center h4">
    		<div class="col-12">
				<div class="alert alert-primary m-2">
          			<linkto :link="'/orders/search'"/>
          			Rendelési tétel módosítás
				</div>
			</div>
	    </div>

	    <div class="container-fluid">
	    	<div class="row d-flex justify-content-center align-items-center text-left h5">
				<div class="col-12 col-sm-6 col-md-3">
					<div class="m-1">
						<span>Rögzítés dátuma:</span>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-md-4 text-center">
					<div class="row d-flex justify-content-center align-items-center">
						<div class="col-8">
							{{order.datum}}
						</div>
						<div class="col-4">
							{{order.datum | day}}
						</div>
				  	</div>
				</div>
				<div class="col-12 col-sm-6 col-md-2">
					<div class="m-1">
						<span>Rögzítette:</span>
				  	</div>
				</div>
				<div class="col-12 col-sm-6 col-md-3">
					<div class="m-1">
						{{order.user}}	
					</div>
				</div>
			</div>
			<div class="row d-flex justify-content-center align-items-center text-left h5">
				<div class="col-12 col-sm-6 col-md-3">
	        		<div class="m-1">
	        			<span>Szállítás kért dátuma:</span>
	        		</div>
	  			</div>
	  			<div class="col-12 col-sm-6 col-md-4 text-center">
	  				<div class="row d-flex justify-content-center align-items-center">
	  					<div class="col-8">
	  						<date-picker
		  						class="text-center"
		  						v-model="order.kidatum"
		  						:config="date_options"
		  						placeholder="Dátum"
		  						:disabled="isClosed"
		  					/>
	  					</div>
	  					<div class="col-4">
	  						{{order.kidatum | day }}
	  					</div>
	  				</div>
	  			</div>
	  			<div class="col-12 col-sm-6 col-md-2">
					<div class="m-1">
						<span>Rendelésszám:</span>
				  	</div>
				</div>
				<div class="col-12 col-sm-6 col-md-3">
					<div class="m-1">
						{{order.rendelesszam}}
						<button
							class="btn btn-success m-1"
							@click.prevent="orderPlus"
						>
							Pluszolás
						</button>
					</div>
				</div>
			</div>
			<div class="row d-flex justify-content-center align-items-center text-left">
				<div class="col-12 col-sm-6 col-lg-3">
					<div class="row d-flex justify-content-center align-items-center">
						<div class="col-12 text-left">
							<label>
								Számla típus:	
							</label>
							<select v-model="order.szla_tipus" class="form-control">
								<option
									v-for="(item,index) in szla_tipusok"
									:key="`sz-${index}`"
									:value="item.id"
									:disabled="item.id === 0"
								>
									{{item.nev}}
								</option>
							</select>
						</div>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-lg-3">
					<div class="row d-flex justify-content-center align-items-center">
						<div class="col-12 text-left">
							<label>
								Számla kiállító:
							</label>
							<select v-model="order.szla_szolg" class="form-control">
								<option
									v-for="(item,index) in szolg"
									:key="`szolg-${index}`"
									:value="item.id"
									:disabled="item.aktiv == 0"
								>
									{{item.nev}}
								</option>
							</select>
						</div>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-lg-3">
					<div class="row d-flex justify-content-center align-items-center">
						<div class="col-12 text-left">
							<label>
								Kiszámlázva:
							</label>
							<select v-model="order.szamlazva" class="form-control">
						  		<option :value="0">Nincs számlázva</option>
						  		<option :value="1">Számlázva</option>
							</select>
						</div>
					</div>
	  			</div>
	  			<div class="col-12 col-sm-6 col-lg-3">
					<div class="row d-flex justify-content-center align-items-center">
						<div class="col-12 text-left">
							<label>
								Állapot:
							</label>
							<select v-model="order.aktiv" class="form-control" :disabled="!isAdmin">
						  		<option :value="'1'">Nyitott</option>
						  		<option :value="'0'">Lezárt</option>
							</select>
						</div>
					</div>
	  			</div>
	  			<div class="col-12 col-sm-6 col-lg-3">
					<div class="row d-flex justify-content-center align-items-center mt-2">
						<div class="col-6 h5 text-right">
							Régió:
						</div>
						<div class="col-6 h4 text-left">
							<input type="number" class="form-control" v-model="order.regio">
						</div>
					</div>
	  			</div>

	  			<div class="col-12 col-md-6 col-lg-3">
		        	<div class="m-1 h5 text-left">
		        		<span class="h6">Kiszállító</span>
		        		<select v-model="order.kiszallito" class="form-control">
							<option value="-1">Nincs</option>
							<option
								v-for="(v,k) in kiszallitok2"
								:key="k"
								:value="v.azon"
							>
								{{ v.nev }}
							</option>
						</select>
					</div>
	        	</div>

	  			<div class="col-12" v-if="invoices.length != 0">
	  				<div class="table table-responsive">
	  					<table class="table">
	  						<thead>
	  							<th>Számla sorszám</th>
	  							<th>Számla dátum</th>
	  						</thead>
	  						<tbody>
	  							<tr v-for="(v,k) in invoices">
	  								<td>
	  									{{ v.invoice_number }}
	  								</td>
	  								<td>
	  									{{ v.invoice_date}}
	  								</td>
	  							</tr>
	  						</tbody>
	  					</table>
	  				</div>
	  			</div>



				<div class="col-12">
					<hr>
				</div>
			</div>
			<div class="row d-flex justify-content-center align-items-center text-left h5">
				<div class="col-12 col-sm-6 col-md-3">
	        		<span>Megrendelő neve:</span><br>
	        		<span class="text-danger h3">
	  					{{order.unev}}
	  				</span>
	  			</div>
	  			<div class="col-12 col-sm-6 col-md-4">
	  				<span>Rendelési megjegyzés:</span>
	  				<textarea class="form-control" v-model="order.rendmegj" rows="3"></textarea>
	  			</div>
				<div class="col-12">
					<hr>
				</div>
			</div>
			<div
				class="row d-flex justify-content-center align-items-center text-left h5"
				v-if="!termekMod"
			>
				<div class="col-12 col-sm-6 col-md-2">
					Termék neve:
				</div>
				<div class="col-12 col-sm-6 col-md-4">
					<span>{{order.tnev}}</span>
					<button
						class="btn btn-primary"
						@click.prevent="setTermekMod(true)"
						v-if="!isClosed"
					>
						Termék módosítása
					</button>
				</div>
				<div class="col-12 col-sm-6 col-md-2">
					<div class="input-group">
					  	<div class="input-group-prepend">
					    	<span class="input-group-text" id="basic-addon1">DB</span>
					  	</div>
					  	<input type="number" class="form-control" v-model="order.db" :disabled="isClosed">
					</div>
				</div>
				<div class="col-12 col-sm-6 col-md-2">
					<div class="input-group">
					  	<div class="input-group-prepend">
					    	<span class="input-group-text" id="basic-addon1">ÁR</span>
					  	</div>
					  	<input type="number" class="form-control" v-model="order.ar" :disabled="isClosed">
					</div>
				</div>
				<div class="col-12 col-sm-6 col-md-2">
					Összesen: {{order.db * order.ar | huf}} Ft
				</div>
			</div>
			<div
				class="row d-flex justify-content-center align-items-center text-left h5"
				v-else
			>
				<div class="col-12 col-sm-6 col-md-2">
					Termék neve:
				</div>
				<div class="col-12 col-sm-6 col-md-4">
					<div class="row d-flex">
						<div class="col-8">
							<select
								class="form-control"
								v-model="order.tszam"
								@change="updateAr($event)"
							>
								<option
									v-for="(v,k) in termekek"
									:value="v.id"
								>
									{{ v.nev }}
								</option>
							</select>
						</div>
						<div class="col-4">
							<button
								class="btn btn-primary"
								@click.prevent="setTermekMod(false)"
							>
								Mégsem
							</button>	
						</div>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-md-2">
					<div class="input-group">
					  	<div class="input-group-prepend">
					    	<span class="input-group-text" id="basic-addon1">DB</span>
					  	</div>
					  	<input type="number" class="form-control" v-model="order.db" :disabled="isClosed">
					</div>
				</div>
				<div class="col-12 col-sm-6 col-md-2">
					<div class="input-group">
					  	<div class="input-group-prepend">
					    	<span class="input-group-text" id="basic-addon1">ÁR</span>
					  	</div>
					  	<input type="number" class="form-control" v-model="order.ar" :disabled="isClosed">
					</div>
				</div>
				<div class="col-12 col-sm-6 col-md-2">
					Összesen: {{order.db * order.ar | huf}} Ft
				</div>
			</div>
			<div class="row d-flex justify-content-center align-items-center text-center">
				<button class="btn btn-lg btn-primary m-2" @click.prevent="savedata">
					Mentés
				</button>
			</div>
	    </div>
  	</div>
</template>
<script type="text/javascript">
import { mapGetters, mapActions } from 'vuex'
export default {
	name: 'order_detail',

	data() {
		return {
			order: {},
			errors: null,
			szolg: [],
			termekek: [],
			termekMod: false,
			tszam: 0,
			db: 0,
			ar: 0,
			invoices: [],
			kiszallitok: [],
			selectedKiszallito: -1
		}
	},

	created(){
		this.getdata()
		this.getinfo()
	},

	methods: {
		...mapActions(['setrendszam','setrenddatum']),

		setTermekMod(val) {
			if(val==true) {
				this.tszam = this.order.tszam
				this.db = this.order.db
				this.ar = this.order.ar
			} else {
				this.order.tszam = this.tszam
				this.order.db = this.db
				this.order.ar = this.ar
			}
			this.termekMod = val
		},

		updateAr(val) {
			let id = val.target.value
			let find = this.termekek.find(x=>x.id==id)
			this.order.ar = find.ar
		},

		getdata(){
			this.req.post('/orders/order/detail', {
				id: this.$route.params.id
			})
				.then(res => {
					this.order = res.data.detail[0]
					this.invoices = res.data.invoices
					this.$Progress.finish()
				})
				.catch(err => {
					console.log(err)
					this.$Progress.fail()
				})
		},

		savedata(){
			this.$Progress.start()
			this.errors = null
	    	this.req.post('/orders/order/save', {
	    		order: this.order,
	    		user: this.$store.getters.user.azon
	    	})
	    		.then(res => {
	    			if(res.data.status === 'error') {
	    				this.errors = res.data.errors
	    			} else {
	    				toastr.success('Mentés sikeres')
	    			}
	    			this.$Progress.finish()
	    		})
	    		.catch(err => {
	    			this.$Progress.fail()
	    			toastr.error(err.response.data.text || 'Rögzítés sikertelen')
	    		})
		},

		getinfo(){
			this.$Progress.start()
	      	this.req.post('/others', {
	      		datum: this.order.kidatum
	      	})
	          	.then(res => {
	              	this.szolg = res.data.szolg
	              	this.termekek = res.data.termekek
	              	this.kiszallitok = res.data.kiszallitok
	              	this.$Progress.finish()
	          	})
	          	.catch(err => {
	              	this.$Progress.fail()
	          	})
		},

		orderPlus() {
			this.req.post('/customers/getdata', {
				id: this.order.uszam
			})
				.then(res => {
					this.$store.dispatch('setrendselcustomer',res.data.customer)
					this.setrendszam(this.order.rendelesszam)
					this.setrenddatum(this.order.kidatum)
					this.$router.replace(`/orders/new_order/products?plus=1`)
				})
				.catch(err => {
					console.error(err)
					toastr.error(err)
				})
		}
	},

	computed: {
		isClosed(){
			if(this.$store.getters.user.admin === 1) return false
			return this.order.aktiv === `0`
		},

		kiszallitok2() {
			let r = this.order.regio
			let arr = this.kiszallitok.filter(x => r >= x.regio && r <= x.regio_max)
			return arr
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/orders/single_order.vue